import {css} from 'lit';

function waitForStylesToApply(styleElement) {
  // Create a MutationObserver to observe when the element is added to the DOM and when styles are applied
  const observer = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1 && node.classList.contains('slds-button')) {
          // Check if the element has the expected applied styles (to confirm the render has finished)
          const computedStyle = getComputedStyle(node);
          const expectedFont = "Segoe UI"; // A font from the system stack to confirm SLDS styles are applied

          // Check if the font is applied
          if (computedStyle.fontFamily.includes(expectedFont)) {
            styleElement.remove(); // Remove the hiding state once the style is applied
            observer.disconnect(); // Stop observing once done
            node.remove(); // Clean up the test element
          }
        }
      });
    });
  });

  // Start observing the body for added nodes in the DOM
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Create a test element with a known SLDS class
  const testElement = document.createElement("div");
  testElement.classList.add("slds-button"); // A known SLDS-styled class
  document.body.appendChild(testElement);
}

export function loadGlobalStyles() {
  const fragment = document.createDocumentFragment();

  // Check for existing stylesheet
  const existingLink = document.querySelector('link[href="/main.css"]');
  if (existingLink) {
    const clonedLink = existingLink.cloneNode();
    const style = document.createElement('style');
    style.textContent = `:host { visibility: hidden; }`; // Hide initially
    fragment.appendChild(clonedLink);
    fragment.appendChild(style);

    // If stylesheet is already loaded, verify applied styles
    if (existingLink.sheet) {
      waitForStylesToApply(style);
    } else {
      clonedLink.onload = () => waitForStylesToApply(style);
    }

    return fragment;
  }

  // Create new stylesheet link
  const link = document.createElement('link');
  link.setAttribute('rel', 'stylesheet');
  link.setAttribute('href', '/main.css');

  // Create style to hide component initially
  const style = document.createElement('style');
  style.textContent = `:host { visibility: hidden; }`;

  fragment.appendChild(link);
  fragment.appendChild(style);

  // Remove hiding style once styles are loaded and applied
  link.onload = () => waitForStylesToApply(style);

  return fragment;
}

export function videoPlayerCss() {
  return css`
    .background {
      background-color: black;
      max-width: 100%;
      min-height: 30rem;
      min-width: 24rem;
      border-radius: 0.25rem;
      position: relative;
      text-align: center;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    div.presenting {
      display: inline-block;
      height: 5rem;
      width: 5rem;
      position: absolute;
      background-color: rgba(0, 0, 0, 0.75);
      border-radius: 50%;
    }
    .presenting-icon>svg {
      margin-top: 1.45rem;
      margin-left: 0.25rem;
    }
    p.length {
      position: absolute;
      right: 1rem;
      bottom: 1rem;
      background-color: rgba(0, 0, 0, 0.8);
      padding: 0.125rem 0.25rem;
      border-radius: 0.5rem;
      color: white;
      animation: fadeOut 3s ease-in-out;
    }
    img, video {
      object-fit: contain;
      max-height: 30rem;
      width: 100%;
      margin-left: auto;
      margin-right: auto;
    }
    .sound-toggle {
      position: absolute;
      left: 1rem;
      bottom: 1rem;
      background-color: rgba(0, 0, 0, 0.8);
      padding: 0.5rem 0.25rem 0.25rem 0.25rem;
      border-radius: 50%;
      color: white;
    }
    .sound-toggle svg {
      margin-top: -0.25rem;
    }
  `;
}

export function setElementTheme(element, theme) {
  if (theme === "dark") {
    element.classList.add('dark');
    element.classList.remove('light');
  }
  else
  {
    element.classList.add('light');
    element.classList.remove('dark');
  }
}